import { render, staticRenderFns } from "./ItemsAssociationInputSelect.vue?vue&type=template&id=fd1ed3a2&scoped=true"
import script from "./ItemsAssociationInputSelect.vue?vue&type=script&lang=js"
export * from "./ItemsAssociationInputSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1ed3a2",
  null
  
)

export default component.exports